import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { segmentTrack } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';

interface WithPharmakonRedirectProps {
  match: { params: { hash: string } };
}
export const WithInsuranceRedirect: FC<WithPharmakonRedirectProps> = props => {
  const [hasRedirected, setHasRedirected] = useState(false);
  const dispatch = useDispatch();
  const shortUrlHash = props?.match?.params?.hash;
  useEffect(() => {
    if (shortUrlHash && !hasRedirected) {
      setHasRedirected(true);
      dispatch(segmentTrack(UNIFIED.viewInsuranceRedirectPage, {}));
      // Normally we would never call pharmakon directly from web, but the CDN does this already and the phk
      // endpoint is just a redirect where we send a hash and it returns the redirect url.
      window.location.replace(`${process.env.NEXT_PUBLIC_PHARMAKON_API_URL}/v2/cc/${shortUrlHash}`);
    }
  }, [dispatch, hasRedirected, shortUrlHash]);

  return null;
};
